// lib/getTestimonials.ts
import en from "@/assets/data/testimonials.en";
import ar from "@/assets/data/testimonials.ar";

export function getTestimonials(locale: string) {
  switch (locale) {
    case "ar":
      return ar;
    case "en":
    default:
      return en;
  }
}
